module.exports = __webpack_public_path__ + "static/18-0aa6abe787e9cf7ea4e20fe99772ecda.mp4";